import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';

let isLast = false;

class Supply extends React.Component <{}, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      page: 1,
      pageSize: 15,
    };
  }
  public loadBtn = true;
  public componentDidMount() {
    this._getData();
    const _THIS = this;
      window.onscroll = function() {
        if(document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50||document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
            if(!_THIS.loadBtn){
                return ;
            }
            // (document.querySelector('#loading') as HTMLElement).style.display = 'block';
            _THIS.setState({
                page: _THIS.state.page + 1,
            }, () => {
                if (_THIS.loadBtn) {
                    _THIS._getData();
                    
                }
            });
        }
      }
  }

 

  render() {
    const { dataList } = this.state;

    return (
      <div>
        {
            this.state.dataList.length > 0 ?
            <div>
              <ul className="supply">
                
                {
                  dataList.map((v: any, k: number) => {
                      return (
                        <li key={k}>
                            <p className="purchase-name">{v.spBreed}/{v.spGrade}<span>{v.spItemStateName}</span></p>
                            <p className="purchase-price"><i>￥{v.spPrice}/吨</i>｜{v.spNumber}｜{v.spFactory}｜{v.spArea}<a href={`tel:${v.phone ? v.phone : ''}`} className="phone"><img src={require('@/assets/images/phone.png')} alt="" /></a></p>
                        </li>
                      )
                  })
                }
              </ul>
              { isLast ? '' : <div className="purchaseloading" id="loading"><img src="images/gif.gif" /><span>正在加载...</span></div> }
            </div> : ''
        }

        {
          (this.state.dataList.length <= 0) ?
          <div className="upgrade">
            <div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>您没有任何供应信息</p></div>
            <div className="upgrade-btm">
                  <div className="upgrade-btn"><a href="javascript:;" className="release" onClick={() => (this.props as any).history.push('/releaseSupple') } >发布供应</a></div>
              </div>
          </div> : ''
        }
      </div>
    );
  }

  private  async _getData() {
    
    if(!this.loadBtn) {
        return ;
    }
    this.loadBtn = false;


    const r = await request({
        method: 'post',
        data: {
          pageNum: this.state.page,
          pageSize: this.state.pageSize,
        },
        url: `${config.API2}member/sp/list`,
    })

    if(r.code === 1) {
        if(r.obj.isLastPage) {
            this.loadBtn = false;
            isLast = true;
        }else {
            this.loadBtn = true;
        }

        this.setState({
            dataList: this.state.dataList.concat( r.obj.list),
        })
    }
  }

}

export default Supply;
